import { Prismic, PrismicText } from '@landsbankinn/prismic';
import { Container } from '@landsbankinn/ui';
import isEmpty from 'lodash.isempty';
import React from 'react';
import { InfoCard, ListItem } from '../components/info-card/InfoCard';

interface IProps {
  title: Prismic.RichText;
  copy: Prismic.RichText;
  image: Prismic.Image;
  insurance: string;
  terms: Prismic.Link;
  fields: [IField];
}

interface IField {
  first_text: Prismic.RichText;
  second_text: Prismic.RichText;
}

export const PaymentCardInfoContainer = ({
  title,
  copy,
  image,
  insurance,
  terms,
  fields,
}: IProps) => {
  return (
    <Container className={'payment-info'}>
      <InfoCard
        image={image}
        ar="card"
        title={Prismic.text(title)}
        copy={<PrismicText value={copy} />}
        insurance={insurance}
        link={terms}
      >
        {!isEmpty(fields) &&
          fields.map(({ first_text, second_text }, i: number) => {
            return (
              <ListItem
                key={`${i}-${Prismic.text(first_text)}`}
                title={Prismic.text(first_text)}
                subtitle={second_text}
              />
            );
          })}
      </InfoCard>
    </Container>
  );
};
